import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {EstimatedTax} from './EstimatedTax/EstimatedTax';
import s from '../OrderSummary.scss';
import {TotalShipping} from './TotalShipping/TotalShipping';
import {DeliveryMethod} from './DeliveryMethod/DeliveryMethod';
import {DeliveryError} from './DeliveryError/DeliveryError';
import {DeliveryNotification} from './DeliveryNotification/DeliveryNotification';
import {AdditionalFees} from './AdditionalFees/AdditionalFees';
import {TotalUpdateSkeleton} from './TotalUpdateSkeleton';

export enum SubTotalsDataHook {
  Root = 'SubTotals.Root',
  Value = 'SubTotals.Value',
}

const SubTotal = () => {
  const {t} = useTranslation();
  const {cartSummary, changeCartLoaders, isSummaryUpdating} = useControllerProps().cartStore;

  return (
    <dl className={s.line}>
      <dt>{t('cart.subtotal')}</dt>
      <dd data-hook={SubTotalsDataHook.Value} data-wix-sub-totals-value={SubTotalsDataHook.Value}>
        {changeCartLoaders && isSummaryUpdating ? (
          <TotalUpdateSkeleton />
        ) : (
          cartSummary.priceSummary.subtotal.formattedConvertedAmount
        )}
      </dd>
    </dl>
  );
};

export const SubTotals = () => {
  const {
    shouldDisplaySubtotal,
    shouldDisplayDelivery,
    shouldDisplayDeliveryMethodSelection,
    shouldDisplayTax,
    shouldDisplayDeliveryError,
    isFullAddressRequired,
    shouldDisplayAdditionalFees,
  } = useControllerProps().orderStore;

  if (!shouldDisplaySubtotal) {
    return null;
  }

  return (
    <div data-hook={SubTotalsDataHook.Root} className={s.divider}>
      <SubTotal />

      {shouldDisplayAdditionalFees && (
        <AdditionalFees
          shouldShowDivider={
            shouldDisplayDelivery ||
            shouldDisplayDeliveryMethodSelection ||
            shouldDisplayTax ||
            shouldDisplayDeliveryError
          }
        />
      )}

      {shouldDisplayDelivery && <TotalShipping />}

      {shouldDisplayDeliveryMethodSelection && <DeliveryMethod />}

      {shouldDisplayTax && <EstimatedTax />}

      {shouldDisplayDeliveryError && (isFullAddressRequired ? <DeliveryNotification /> : <DeliveryError />)}
    </div>
  );
};
